
export const environment = {
  production: false,
  name: 'Development',
  isAdminCenter: true
};
